import { states } from '@/constants/lifecycle';
import Fetch, { fetchConfig } from '@/hooks/fetch';
import { requestSources } from '../../constants';
import actions from '../constants';

export default {
  useFetchRequestWorkspace: ({
    code, active, workspaceCreated, workspaceReadStatus,
  }, readStatus) => Fetch.useFetchDispatch(
    actions.FETCH_REQUEST_WORKSPACE,
    states.NONE,
    { code },
    fetchConfig(
      [active],
      () => !workspaceCreated && readStatus === states.SUCCESS && (active || workspaceReadStatus === states.NONE),
    ),
  ),
  useFetchRequestWorkspaces: ({
    category, code, location, entity, locationsReadStatus,
  }, readStatus) => Fetch.useFetchDispatch(
    actions.FETCH_REQUEST_WORKSPACES,
    readStatus,
    { category, code, location },
    fetchConfig(
      [category, code, location, entity, locationsReadStatus],
      () => locationsReadStatus === states.SUCCESS && Object.values(requestSources).includes(entity),
    ),
  ),
  useFetchWorkspaceFormForRequest: ({ category, code, intl }, readStatus) => Fetch.useFetchDispatch(
    actions.FETCH_WORKSPACE_FORM_FOR_REQUEST,
    readStatus,
    { category, code, intl },
  ),
};
